@let list = spaces();
@let current = lookup();
<div class="scrim" (click)="close()"></div>
<section class="sheet" role="dialog" aria-modal="true" [attr.aria-label]="'Spaces' | translate">
  <div class="grabber" aria-hidden="true"></div>
  <header class="sheet-header">
    <h3>
      <fa-duotone-icon [icon]="faArrowRightArrowLeft"></fa-duotone-icon>
      {{ (adding() ? 'Add Space' : 'Spaces') | translate }}
    </h3>
    @if (!required()) {
      <button
        type="button"
        class="close-btn"
        [attr.aria-label]="'Close' | translate"
        (click)="close()">
        <fa-duotone-icon [icon]="faXmark"></fa-duotone-icon>
      </button>
    }
  </header>

  @if (adding()) {
    <p class="intro">
      {{ 'Enter the address of a Rooms space or paste an invite link.' | translate }}
    </p>
    <andor-text-field
      [formControl]="address"
      [label]="'Address' | translate"
      placeholder="rooms.example.com"></andor-text-field>

    <div class="preview" [class.preview--found]="current.state === 'found'">
      @switch (current.state) {
        @case ('loading') {
          <span class="preview__hint">
            {{ 'Looking up [domain]…' | translate: { domain: current.domain } }}
          </span>
        }
        @case ('found') {
          @if (logo(current.space); as src) {
            <img [src]="src" alt="" crossorigin="anonymous" />
          }
          <b>{{ current.space.title }}</b>
          <span class="preview__hint">{{ current.space.domain }}</span>
        }
        @case ('error') {
          <span class="preview__error">{{ current.message | translate }}</span>
        }
        @default {
          <span class="preview__hint">{{ 'The space appears here.' | translate }}</span>
        }
      }
    </div>

    <div class="actions">
      @if (list.spaces.length > 0) {
        <andor-button (click)="cancelForm()">
          <span>{{ 'Cancel' | translate }}</span>
        </andor-button>
      }
      <andor-button type="gradient" [disabled]="current.state !== 'found'" (click)="add()">
        <span>{{ 'Add Space' | translate }}</span>
      </andor-button>
    </div>
  } @else {
    <ul class="spaces">
      @for (space of list.spaces; track space.domain) {
        @let active = space.domain === list.active;
        <li class="space" [class.space--active]="active">
          <button type="button" class="space__pick" (click)="select(space)">
            @if (logo(space); as src) {
              <img [src]="src" alt="" crossorigin="anonymous" />
            }
            <span class="space__meta">
              <b>{{ space.title }}</b>
              <small>{{ space.domain }}</small>
            </span>
            @if (active) {
              <fa-duotone-icon class="space__check" [icon]="faCircleCheck"></fa-duotone-icon>
            }
          </button>
          <button
            type="button"
            class="space__remove"
            [attr.aria-label]="'Remove Space' | translate"
            (click)="remove(space)">
            <fa-duotone-icon [icon]="faTrashCan"></fa-duotone-icon>
          </button>
        </li>
      }
    </ul>
    <button type="button" class="space-add" (click)="showForm()">
      <fa-duotone-icon [icon]="faPlus"></fa-duotone-icon>
      {{ 'Add Space' | translate }}
    </button>
  }
</section>
